import script from "./InputText.vue?vue&type=script&setup=true&lang=js"
export * from "./InputText.vue?vue&type=script&setup=true&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=f48ad972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f48ad972"]])

export default __exports__